module.exports = __webpack_public_path__ + "9e88fe0d7eef6e13218f4216f9932213.pdf";